import { removeFromShortlist } from '../../../../services/popupApi';

export const api = {
  onOk: async (context) => {
    await removeFromShortlist({
      jobId: context.jobId ?? context.selectedIds[0],
      candidateIds: context.selectedIds,
    });
  },
};
